var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-status",class:[_vm.statusColorClass]},[_c('div',{staticClass:"order-status__marker"}),_c('p',{staticClass:"order-status__text"},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }